export default __webpack_public_path__ + "static/media/meet3.4d2b19c7.png";